<template>
  <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.9999 4.9069H16.1222V2H7.87782V4.9069H3V6.64562H4.65477L5.77241 22H18.2277L19.3453 6.64562H21L20.9999 4.9069ZM9.55427 3.73872H14.4457V4.9069H9.55427V3.73872ZM16.6731 20.2613H7.32705L6.33592 6.64562H17.6641L16.6731 20.2613Z"
      class="fill-current"
    />
    <path d="M12.6706 9.61477H11.3294V17.292H12.6706V9.61477Z" class="fill-current" />
    <path d="M10.1 9.61477H8.75885V17.292H10.1V9.61477Z" class="fill-current" />
    <path d="M15.2411 9.61477H13.9V17.292H15.2411V9.61477Z" class="fill-current" />
  </svg>
</template>
